import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import Chip from "@mui/material/Chip";

import { chipStyles } from "./constants";

const FilterChip = ({ label, variant = "neutral", onDelete }) => {
  const style = chipStyles[variant] ?? chipStyles.neutral;

  return (
    <Chip
      size="small"
      label={label}
      onDelete={onDelete}
      deleteIcon={
        onDelete ? (
          <CloseRoundedIcon
            sx={{ fontSize: "13px !important", color: `${style.color} !important`, opacity: 0.7 }}
          />
        ) : undefined
      }
      sx={{
        height: 24,
        borderRadius: "12px",
        backgroundColor: style.bg,
        color: style.color,
        fontWeight: 500,
        fontSize: 12,
        border: "none",
        "& .MuiChip-label": { px: 1.25 },
        "& .MuiChip-deleteIcon": { mr: 0.5 },
      }}
    />
  );
};

export default FilterChip;
